export default "__VITE_ASSET__DxoViwT0__"